import React from 'react'
import * as S from './ChargeCodeModalContent.styles'

export const CHARGE_CODE_VALIDATIONS = {
  inactive: {
    condition: (chargeCode) => chargeCode.isActive !== null && !chargeCode.isActive,
    message: 'Charge code is inactive or invalid'
  },
  notChargeable: {
    condition: (chargeCode) => chargeCode.isActive && chargeCode.isChargeable !== null && !chargeCode.isChargeable,
    message: 'Charge code is not chargeable'
  },
  nonClient: {
    condition: (chargeCode) => chargeCode.isActive && chargeCode.isChargeable && chargeCode.isClient !== null && !chargeCode.isClient,
    message: "Non-client charge code can't be used for download"
  },
  tooShort: {
    condition: (chargeCode) => chargeCode.value.length < 8 && chargeCode.value !== '',
    message: 'Charge code must be at least 8 characters long'
  }
}

export function ValidationErrorMessage({ validationKey, chargeCode, isEnabled }) {
  const validation = CHARGE_CODE_VALIDATIONS[validationKey]
  const shouldShow = validationKey === 'tooShort'
    ? isEnabled && validation.condition(chargeCode)
    : validation.condition(chargeCode)

  if (!shouldShow) return null

  return (
    <S.InvalidChargeCode>
      {validation.message}
    </S.InvalidChargeCode>
  )
}

export function isChargeCodeValid(chargeCode) {
  return chargeCode && chargeCode.isActive && chargeCode.isChargeable && chargeCode.isClient
}
